export const prefillData = (dye) => {
    switch (dye) {
        case '405':
            return {
                excitation_wavelength:'401',
                emission_wavelength: '422',
                extinction_coefficient: '34000',
                molecular_weight: '1028.3',
                emission_color: 'Blue'
            }
        case '488':
            return {
                excitation_wavelength: '490',
                emission_wavelength: '525',
                extinction_coefficient: '71000',
                molecular_weight: '643',
                emission_color: 'Green'
            }
        case '532':
            return {
                excitation_wavelength: '534',
                emission_wavelength: '553',
                extinction_coefficient: '81000',
                molecular_weight: '721',
                emission_color: 'Yellow'
            }
        case '555':
            return {
                excitation_wavelength: '553',
                emission_wavelength: '568',
                extinction_coefficient: '150000',
                molecular_weight: '1250',
                emission_color: 'Orange'
            }
        case '594':
            return {
                excitation_wavelength: '590',
                emission_wavelength: '617',
                extinction_coefficient: '90000',
                molecular_weight: '820',
                emission_color: 'Orange/Red'
            }
        case '647':
            return {
                excitation_wavelength: '650',
                emission_wavelength: '671',
                extinction_coefficient: '239000',
                molecular_weight: '1300',
                emission_color: 'Red'
            }
        case '680':
            return {
                excitation_wavelength: '679',
                emission_wavelength: '702',
                extinction_coefficient: '184000',
                molecular_weight: '1150',
                emission_color: 'Red (NIR)'
            }   
        case '750':
            return {
                excitation_wavelength: '749',
                emission_wavelength: '775',
                extinction_coefficient: '240000',
                molecular_weight: '1300',
                emission_color: 'Far Red (NIR)'
            }   
        case '790':
            return {
                excitation_wavelength: '784',
                emission_wavelength: '814',
                extinction_coefficient: '270000',
                molecular_weight: '1750',
                emission_color: 'Far Red (NIR)'
            }
    }
}